import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

export class PaymentWarnApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealerInformation/getBlockedPayments',
      requesterInfo,
    })
  }

  public async getWarn(): Promise<string> {
    return await this.getAsync<string>()
  }
}
